import { useState } from "react";

function CollapseView({
  stock,
  onApproveReceive,
  onApproveRequest,
  onApprovePartialRequest,
  onApproveReconcile,
  onDispatchRequest,
  onEdit,
  onClickAction,
}) {
  const [showDisapprove, setShowDisapprove] = useState(false);

  const handleToggle = () => setShowDisapprove((prev) => !prev);

  const toNum = (v) => (Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0);

  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Store:</strong> {stock?.destinationLocation?.name}
        </p>
        <p className="mb-1">
          <strong>Request Number:</strong> {stock?.requestNumber}
        </p>
        <p className="mb-1">
          <strong>Request Date:</strong>{" "}
          {stock?.requestDate &&
            new Date(stock?.requestDate).toLocaleString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
        </p>
        <p className="mb-1">
          <strong>Dispatched QTY:</strong>
        </p>
        <ul className="mb-2">
          {(stock?.items || []).map((item) => (
            <li key={item.sku}>
              {item.itemName}: {parseFloat(item.quantityApprove || 0)}
            </li>
          ))}
        </ul>

        <p className="mb-1">
          <strong>Received QTY:</strong>
        </p>
        <ul className="mb-2">
          {(stock?.items || []).map((item) => (
            <li key={item.sku}>
              {item.itemName}: {parseFloat(item.quantityReceive || 0)}
            </li>
          ))}
        </ul>

        <p className="mb-1">
          <strong>Remaining QTY:</strong>
        </p>
        <ul className="mb-2">
          {/* {(stock?.items || []).map((item) => {
            const dispatched = toNum(item.quantityApprove ?? item.quantity);
            const received = toNum(item.quantityReceive ?? 0);
            const remaining = Math.max(0, dispatched - received);
            return (
              <li key={item.sku}>
                {item.itemName}: {remaining}
              </li>
            );
          })} */}
          {(stock?.items || []).map((item) => (
            <li key={item.sku}>
              {item.itemName}: {parseFloat(item.remainingQty || 0)}
            </li>
          ))}
        </ul>
      </div>

      <div className="d-flex gap-2 align-items-center position-relative">
        {stock?.status === "Pending" && (
          <button
            className="btn btn-success text-white"
            onClick={onApproveRequest}
          >
            <i className="bi bi-check me-2"></i> Approve
          </button>
        )}

        {stock?.status === "Pending Partially Received" && (
          <button
            className="btn btn-success text-white"
            onClick={onApprovePartialRequest}
          >
            <i className="bi bi-check me-2"></i> Approve
          </button>
        )}

        {stock?.status === "Pending Fully Received" && (
          <button
            className="btn btn-success text-white"
            onClick={onApproveReceive}
          >
            <i className="bi bi-check me-2"></i> Approve
          </button>
        )}

        {stock?.status === "For Reconciliation" && (
          <button
            className="btn btn-success text-white"
            onClick={onApproveReconcile}
          >
            <i className="bi bi-check me-2"></i> Approve
          </button>
        )}

        {["Approved", "Partially Received"].includes(stock?.status) && (
          <button
            className="btn text-white"
            style={{ backgroundColor: "#82c14a" }}
            onClick={onDispatchRequest}
          >
            Dispatch
          </button>
        )}

        <button
          className="btn text-dark"
          style={{ backgroundColor: "#d1d1d1" }}
          onClick={onEdit}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>

        {!["Cancelled", "Disapproved"].includes(stock?.status) && (
          <button
            className="btn text-white"
            onClick={handleToggle}
            style={{ backgroundColor: "white", boxShadow: "none" }}
          >
            <i
              className="bi bi-three-dots-vertical fw-bold"
              style={{ color: "black", fontSize: "20px" }}
            ></i>
          </button>
        )}

        {showDisapprove && (
          <div
            className="position-absolute"
            style={{
              top: "1%",
              right: 500,
              zIndex: 999,
              marginTop: "4px",
            }}
          >
            <button
              className="btn text-white px-4"
              style={{
                backgroundColor: "#e74c3c",
                borderRadius: "20px",
              }}
              onClick={onClickAction}
            >
              <i className="bi bi-x me-2"></i> Disapprove
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CollapseView;
